import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { OnyxEvent } from '../../models/event';
import { Rsvp } from '../../models/rsvp';
import { RsvpFormComponent } from '../rsvp-form/rsvp-form.component';

@Component({
  selector: 'pioneer-rsvp-modal',
  templateUrl: './rsvp-modal.component.html'
})
export class RsvpModalComponent implements OnInit {

  @ViewChild(ModalDirective) rsvpModal: ModalDirective;
  @ViewChild(RsvpFormComponent) rsvpFormComponent: RsvpFormComponent;

  @Output() closed = new EventEmitter();
  @Input() event: OnyxEvent;
  @Input() config = {
    backdrop: 'static',
    keyboard: false
  };

  title: string;
  placeholder: string;
  rsvp: Rsvp;

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.title = this.translateService.instant('EVENT.EDIT_RSVP_MODAL.TITLE');
  }

  open(rsvp: Rsvp) {
    if (!this.event) {
      throw new Error(this.translateService.instant('EVENT.EDIT_RSVP_MODAL.NO_EVENT_ERROR'));
    }
    if (!rsvp) {
      throw new Error(this.translateService.instant('EVENT.EDIT_RSVP_MODAL.NO_RSVP_ERROR'));
    }

    this.rsvp = rsvp;
    this.rsvpFormComponent.init(rsvp);
    this.rsvpModal.show();
  }

  close(value: boolean) {
    this.closed.emit(value);
    this.rsvpModal.hide();
  }

  cancel() {
    this.rsvpFormComponent.cancelEditRsvp();
    this.close(false);
  }

  accept(): Observable<any> {
    let obs: Observable<any> = new Observable();

    obs = this.rsvpFormComponent.updateRsvp(this.rsvp.eventRsvpId);
    obs.subscribe(() => { this.close(true); });

    return obs;
  }

  disableSave(): boolean {
    let disable: boolean;

    if (this.rsvpFormComponent && this.rsvpFormComponent.rsvpForm) {
      disable = !this.rsvpFormComponent.rsvpForm.valid;
    } else {
      disable = true;
    }

    return disable;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rsvp/rsvp-modal/rsvp-modal.component.ts